<template>
    <!-- First Hero Banner Section (Large) -->
    <UiHeroTop v-if="blogStore.filterArticlesByTag(blog, 'Herobanner')[0]" 
      :article="blogStore.filterArticlesByTag(blog, 'Herobanner')[0]" />

      <UiImageFlip v-if="blogStore.filterArticlesByTag(blog, 'Heroextra')[0]"
      :article="blogStore.filterArticlesByTag(blog, 'Heroextra')[0]" 
      class="smallscreen"/>

      <UiHeroSpecial v-if="blogStore.filterArticlesByTag(blog, 'Herosecond')[0]"
      :article="blogStore.filterArticlesByTag(blog, 'Herosecond')[0]" />
  
</template>
  
  
<script setup>
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();

// Definiera props
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});

</script>
  
<style scoped>
@media (max-width: 480px) { /* Extra small screens */
  .smallscreen {
    margin-bottom: 24px;
    margin-top: 24px;
  }
}

</style>
  